export default __webpack_public_path__ + "static/media/rt-team-1-tony.4ce552cb.png";